import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale
  },
  zh: {
    ...zhLocale
  }
}

// 设置默认语言为中文
const defaultLanguage = localStorage.getItem('lang') || 'zh';
localStorage.setItem('lang', defaultLanguage);

export default new VueI18n({
  locale: defaultLanguage,
  messages,
  silentTranslationWarn: true
})